import React from 'react';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib';

import { pt } from '../../common/utils';
import img from '../../common/img';

const Jdbeans = (props) => {
    const { jdbeans, allJdbeans, jdbeansNum, setJdbeans, jdbeansCount, onlinePayFee, coupon, isJdbeansError, cardUseNum, seatsCount } = props;

    return (
        isJdbeansError
            ? <View style={ st.jdbeans }>
                <JDText style={ st.txt }>0京豆可用</JDText>
            </View>
            : allJdbeans > 0 && <View style={ st.jdbeans }>
                {
                    jdbeansCount >= 3
                        ? <View style={ st.left }>
                            <JDText style={ st.txt }>
                                共
                                <JDText type='regular'>{allJdbeans}</JDText>
                                京豆
                            </JDText>
                            <View style={ st.v_txt }>
                                <JDText style={ st.is_use }>京豆使用到达上限</JDText>
                            </View>
                        </View>
                        : ((onlinePayFee === 0 && cardUseNum == seatsCount) || (onlinePayFee === 0 && coupon > 0 && jdbeansNum <= 0) || (onlinePayFee === 0 && coupon > 0 && !jdbeans))
                            ? <View style={ st.left }>
                                <JDText style={ st.txt }>
                                    共
                                    <JDText type='regular'>{allJdbeans}</JDText>
                                    京豆
                                </JDText>
                                <View style={ st.v_txt }>
                                    <JDText style={ st.is_use }>无可用</JDText>
                                </View>
                            </View>
                            : <JDText style={ st.txt }>
                                共
                                <JDText type='regular'>{allJdbeans}</JDText>
                                京豆，{jdbeans ? '已' : '可'}用{jdbeansNum}京豆，抵
                                <JDText type='regular'>&yen;{jdbeansNum / 100}</JDText>
                                元
                            </JDText>

                }

                {
                    (jdbeansNum > 0 && (jdbeansCount < 3 && (onlinePayFee > 0)) || (jdbeans && jdbeansNum > 0 && coupon > 0) || (jdbeans && jdbeansNum > 0 && onlinePayFee == 0)) &&
                    <JDTouchable onPress={ setJdbeans } >
                        <JDImage style={ st.btn } source={ jdbeans ? img.on : img.off } />
                    </JDTouchable>
                }

            </View>
    );
};

const st = StyleSheet.create({
    jdbeans: {
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        backgroundColor: '#fff',
        padding: pt(10),
        paddingVertical: pt(5),
        height: pt(38)
    },
    txt: {
        fontSize: pt(12)
    },
    left: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    v_txt: {
        borderRadius: pt(4),
        paddingHorizontal: pt(5),
        paddingVertical: pt(2),
        backgroundColor: 'rgba(217, 217, 217, 1)',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: pt(3),
        height: pt(18)
    },
    is_use: {
        color: '#fff',
        fontSize: pt(12)
    },
    btn: {
        height: pt(24),
        width: pt(48)
    }
});

export default Jdbeans;
